import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./auth-config";

// Single MSAL instance shared across the entire application
// This follows Microsoft's best practice: "PublicClientApplication should only be initialized once per page load"
export const msalInstance = new PublicClientApplication(msalConfig);

// Promise that resolves when MSAL is fully initialized
export const msalInitPromise = msalInstance.initialize();
